export enum TagType {
  Workspace = 0,
  Personal = 1,
}

export default TagType;
